import React from "react";
import toast from "react-hot-toast";

const Toast = (type = "default", msg) => {
  toast.dismiss();
  const toastTypes = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warning,
    default: toast, // Default toast
  };

  // Call the appropriate toast function or fallback to default
  (toastTypes[type] || toastTypes.default)(msg, {
    duration: 4000,
    position: "bottom-center",

    // Additional Configuration
    ariaProps: {
      role: "status",
      "aria-live": "polite",
    },
    removeDelay: 1000,
  });
};

export default Toast;
